import { render, staticRenderFns } from "./SnowSwitch.vue?vue&type=template&id=920d4d76&scoped=true&"
import script from "./SnowSwitch.vue?vue&type=script&lang=js&"
export * from "./SnowSwitch.vue?vue&type=script&lang=js&"
import style0 from "./SnowSwitch.vue?vue&type=style&index=0&id=920d4d76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "920d4d76",
  null
  
)

export default component.exports